import Loadable from "@loadable/component";

const ShopByBrandsPage = Loadable(
  () => import(/* webpackChunkName: "shop_by_brands_page" */ "./shopByBrands")
);

export default ShopByBrandsPage;
